import { render, staticRenderFns } from "./TicoursesView.vue?vue&type=template&id=22412bcc"
import script from "./TicoursesView.vue?vue&type=script&lang=js"
export * from "./TicoursesView.vue?vue&type=script&lang=js"
import style0 from "./TicoursesView.vue?vue&type=style&index=0&id=22412bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports